import { Alert, Card, styled } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import { AddProductsBySKUForm } from '../../../admin/product-management/AddProductsBySKUForm';
import { useTranslation } from 'react-i18next';
import { GeneralQueryCard } from '../../../admin/product-management/GeneralQueryCard';
import useAdminProductManagement from '../../../../hooks/admin/useAdminProductManagement';
import useAdminTaskRunSWR from '../../../../hooks/admin/useAdminTaskRunSWR';
import { isNullOrUndefined } from '../../../../utils/utils';

const StyledCard = styled(Card)(() => ({
    width: '100%',
    marginBottom: '15px',
}));

export const AdminProductsManagement = () => {
    const { t } = useTranslation('admin', {
        keyPrefix: 'PRODUCTS_MANAGEMENT',
    });

    const [isProcessLoading, setIsProcessLoading] = useState(false);
    const adminProductManagement = useAdminProductManagement();
    const { runningProcess, isLoading, forceRefresh, isValidating } =
        useAdminTaskRunSWR();

    useEffect(() => {
        if (
            runningProcess &&
            !isNullOrUndefined(runningProcess.runningProcess)
        ) {
            setIsProcessLoading(true);
        } else {
            setIsProcessLoading(false);
        }
    }, [runningProcess, isLoading, isValidating]);

    const create = (list) => {
        return list.split(',').map((elem) => {
            return {
                sku: elem.trim(),
            };
        });
    };
    const productsBySKUSubmit = (skuList) => {
        setIsProcessLoading(true);
        adminProductManagement
            .getProductsBySKUFromBC({
                products: create(skuList),
            })
            .then(() => {
                forceRefresh().then();
            });
    };

    const allProductsSubmit = () => {
        setIsProcessLoading(true);
        adminProductManagement.getAllProductsFromBC().then((resp) => {
            forceRefresh().then();
        });
    };

    const stockSubmit = () => {
        setIsProcessLoading(true);
        adminProductManagement.getBCStock().then((resp) => {
            forceRefresh().then();
        });
    };

    const priceListSubmit = () => {
        setIsProcessLoading(true);
        adminProductManagement.getBCPriceList().then((resp) => {
            forceRefresh().then();
        });
    };

    const metafieldSubmit = () => {
        setIsProcessLoading(true);
        adminProductManagement.setMetafields().then((resp) => {
            forceRefresh().then();
        });
    };

    return (
        <>
            <PageTitle>{t('TITLE')}</PageTitle>
            {isProcessLoading && (
                <Alert variant="filled" severity="warning">
                    {t('IN_PROGRESS')}
                </Alert>
            )}
            <div>
                <StyledCard>
                    <AddProductsBySKUForm
                        isLoading={isProcessLoading}
                        formSubmit={productsBySKUSubmit}
                    />
                </StyledCard>
                <StyledCard>
                    <GeneralQueryCard
                        isLoading={isProcessLoading}
                        formSubmit={allProductsSubmit}
                        translatePrefix={'ALL_PRODUCTS'}
                    />
                </StyledCard>
                <StyledCard>
                    <GeneralQueryCard
                        isLoading={isProcessLoading}
                        formSubmit={stockSubmit}
                        translatePrefix={'STOCK_DATA'}
                    />
                </StyledCard>
                <StyledCard>
                    <GeneralQueryCard
                        isLoading={isProcessLoading}
                        formSubmit={priceListSubmit}
                        translatePrefix={'PRICELIST_RESET'}
                    />
                </StyledCard>
                <StyledCard>
                    <GeneralQueryCard
                        isLoading={isProcessLoading}
                        formSubmit={metafieldSubmit}
                        translatePrefix={'METAFIELD_RESET'}
                    />
                </StyledCard>
            </div>
        </>
    );
};
